import React from 'react';

const AnimatedLeafyBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0 will-change-transform">
      {/* Main leafy shadow overlay */}
      <div className="absolute inset-0 opacity-15 md:opacity-20">
        {/* Layer 1 - Large leaves */}
        <div className="absolute inset-0 animate-float-slow">
          <svg
            className="w-full h-full"
            viewBox="0 0 1200 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="leafShadow1">
                <feGaussianBlur stdDeviation="3" result="blur" />
                <feColorMatrix
                  in="blur"
                  type="matrix"
                  values="0 0 0 0 0.1 0 0 0 0 0.3 0 0 0 0 0.1 0 0 0 0.4 0"
                  result="shadow"
                />
              </filter>
            </defs>
            
            {/* Large leaf shadows. */}
            <path
              d="M100,200 Q150,150 200,200 Q150,250 100,200 Z"
              fill="#0F2F00"
              filter="url(#leafShadow1)"
              className="animate-float"
            />
            <path
              d="M300,100 Q350,50 400,100 Q350,150 300,100 Z"
              fill="#0F2F00"
              filter="url(#leafShadow1)"
              className="animate-float-delayed"
            />
            <path
              d="M500,300 Q550,250 600,300 Q550,350 500,300 Z"
              fill="#0F2F00"
              filter="url(#leafShadow1)"
              className="animate-float-slow"
            />
            <path
              d="M800,150 Q850,100 900,150 Q850,200 800,150 Z"
              fill="#0F2F00"
              filter="url(#leafShadow1)"
              className="animate-float"
            />
            <path
              d="M1000,250 Q1050,200 1100,250 Q1050,300 1000,250 Z"
              fill="#0F2F00"
              filter="url(#leafShadow1)"
              className="animate-float-delayed"
            />
          </svg>
        </div>

        {/* Layer 2 - Medium leaves */}
        <div className="absolute inset-0 animate-float-medium">
          <svg
            className="w-full h-full"
            viewBox="0 0 1200 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="leafShadow2">
                <feGaussianBlur stdDeviation="2" result="blur" />
                <feColorMatrix
                  in="blur"
                  type="matrix"
                  values="0 0 0 0 0.2 0 0 0 0 0.4 0 0 0 0 0.2 0 0 0 0.5 0"
                  result="shadow"
                />
              </filter>
            </defs>
            
            <path
              d="M150,400 Q180,370 210,400 Q180,430 150,400 Z"
              fill="#1A4D0F"
              filter="url(#leafShadow2)"
              className="animate-sway"
            />
            <path
              d="M400,500 Q430,470 460,500 Q430,530 400,500 Z"
              fill="#1A4D0F"
              filter="url(#leafShadow2)"
              className="animate-sway-delayed"
            />
            <path
              d="M700,350 Q730,320 760,350 Q730,380 700,350 Z"
              fill="#1A4D0F"
              filter="url(#leafShadow2)"
              className="animate-sway"
            />
            <path
              d="M950,450 Q980,420 1010,450 Q980,480 950,450 Z"
              fill="#1A4D0F"
              filter="url(#leafShadow2)"
              className="animate-sway-delayed"
            />
          </svg>
        </div>

        {/* Layer 3 - Small leaves */}
        <div className="absolute inset-0 animate-float-fast">
          <svg
            className="w-full h-full"
            viewBox="0 0 1200 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <filter id="leafShadow3">
                <feGaussianBlur stdDeviation="1.5" result="blur" />
                <feColorMatrix
                  in="blur"
                  type="matrix"
                  values="0 0 0 0 0.3 0 0 0 0 0.4 0 0 0 0 0.3 0 0 0 0.6 0"
                  result="shadow"
                />
              </filter>
            </defs>
            
            <path
              d="M80,600 Q95,585 110,600 Q95,615 80,600 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl"
            />
            <path
              d="M250,650 Q265,635 280,650 Q265,665 250,650 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl-delayed"
            />
            <path
              d="M450,580 Q465,565 480,580 Q465,595 450,580 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl"
            />
            <path
              d="M650,620 Q665,605 680,620 Q665,635 650,620 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl-delayed"
            />
            <path
              d="M850,590 Q865,575 880,590 Q865,605 850,590 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl"
            />
            <path
              d="M1050,640 Q1065,625 1080,640 Q1065,655 1050,640 Z"
              fill="#2A6B20"
              filter="url(#leafShadow3)"
              className="animate-twirl-delayed"
            />
          </svg>
        </div>
      </div>

      {/* Subtle gradient overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-transparent via-transparent to-green-900/5" />
    </div>
  );
};

export default AnimatedLeafyBackground;
